const CATEGORY_LIST_URL = "/v1/basket/category-list";
const CATEGORY_SINGLE_URL = "/v1/basket/category-single";
const CATEGORY_ADD_URL = "/v1/basket/category-add";
const CATEGORY_UPDATE_URL = "/v1/basket/category-update";
const CATEGORY_DELETE_URL = "/v1/basket/category-delete";
const BASKET_LIST_URL = "/v1/basket/list";
const STOCK_BASKET_LIST_URL = "/v1/campaign/list";
const STOCK_BASKET_ADD_URL = "/v1/campaign/add";
const STOCK_BASKET_DELETE_URL = "/v1/campaign/remove";
const STOCK_BASKET_SINGLE_URL = "/v1/campaign/single";
const STOCK_BASKET_UPDATE_URL = "/v1/campaign/update";
const BASKET_ADD_URL = "/v1/basket/add";
const BASKET_SINGLE_URL = "/v1/basket/single";
const BASKET_DELETE_URL = "/v1/basket/delete";
const BASKET_UPDATE_URL = "/v1/basket/update";

const BASKET_API_URL_LIST = {
    CATEGORY_LIST_URL,
    CATEGORY_SINGLE_URL,
    CATEGORY_ADD_URL,
    CATEGORY_UPDATE_URL,
    CATEGORY_DELETE_URL,
    BASKET_LIST_URL,
    BASKET_ADD_URL,
    STOCK_BASKET_LIST_URL,
    STOCK_BASKET_ADD_URL,
    STOCK_BASKET_SINGLE_URL,
    BASKET_SINGLE_URL,
    STOCK_BASKET_DELETE_URL,
    BASKET_DELETE_URL,
    BASKET_UPDATE_URL,
    STOCK_BASKET_UPDATE_URL
}

export { BASKET_API_URL_LIST };
